// 約定結果 CSV の受渡日の期間 (AC-BSP-115)。 開始・終了とも含み、 最大 31 日。
// 正本は backend の `valueobject.DeliveryDatePeriod`。 ここは RPC を呼ぶ前に入力を止めるための写し。
import {
  type CivilDate,
  civilDateToDate,
  compareCivilDate,
  isValidCivilDate,
} from '~/models/civilDate'

export const MAX_DELIVERY_DATE_PERIOD_DAYS = 31

export type DeliveryDatePeriod = { from: CivilDate; to: CivilDate }

const DAY_MS = 24 * 60 * 60 * 1000

const inclusiveDays = (from: CivilDate, to: CivilDate): number =>
  Math.round(
    (civilDateToDate(to).getTime() - civilDateToDate(from).getTime()) / DAY_MS,
  ) + 1

/** 期間として受け付けられるか (日付が有効・終了が開始以後・31 日以内)。 */
export const isValidDeliveryDatePeriod = ({
  from,
  to,
}: DeliveryDatePeriod): boolean =>
  isValidCivilDate(from) &&
  isValidCivilDate(to) &&
  compareCivilDate(from, to) <= 0 &&
  inclusiveDays(from, to) <= MAX_DELIVERY_DATE_PERIOD_DAYS
